import { Paper, Table, TableContainer } from '@material-ui/core'
import { ExtAgsTableHead } from './ExtAgsTableHead'
import { ExtAgsTableBody } from './ExtAgsTableBody'

export const ExtAgsTable = ({
  data,
  setOpenDetail,
  openDetail,
  coproprietaire_id,
  copro_id,
  setFile,
}) => (
  <TableContainer component={Paper}>
    <Table sx={{ minWidth: 650 }}>
      <ExtAgsTableHead />
      <ExtAgsTableBody
        data={data}
        setOpenDetail={setOpenDetail}
        openDetail={openDetail}
        coproprietaire_id={coproprietaire_id}
        copro_id={copro_id}
        setFile={setFile}
      />
    </Table>
  </TableContainer>
)
